import awards from "../../shared/de.awards";
import branded_quotes from "../../shared/de.branded-quotes";
import verticals from "./de-education-primary.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "de-education-primary-kontakt":
            return {
                page,
                helmet: {
                    meta_title: "Kontakt | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.de/bildung/kontakt/",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        case "de-education-primary-home":
            return {
                page,
                helmet: {
                    meta_title: "Online-Sprachunterricht für die Bildung | Rosetta Stone",
                    meta_description:
                        "Die Sprachlernlösungen von Rosetta Stone für K-12 passen in den Unterricht der Lehrer und sind jederzeit verfügbar, wenn die Schüler Englisch- oder Weltsprachkenntnisse lernen oder verbessern möchten.",
                    canonical_url: "https://www.rosettastone.de/bildung/",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        case "de-education-primary-loesungen":
            return {
                page,
                helmet: {
                    meta_title: "Online-Sprachlernprogramme für den Bildungsbereich | Rosetta Stone",
                    meta_description:
                        "Die Online-Sprachlernprogramme von Rosetta Stone motivieren Englischlernende und Sprachschüler aus aller Welt, selbstsicher zu sprechen. Fragen Sie nach den Preisen.",
                    canonical_url: "https://www.rosettastone.de/bildung/loesungen/",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        case "de-education-primary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        case "de-education-primary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        case "de-education-primary-404":
            return {
                page,
                helmet: {
                    meta_title: "Site Nicht Gefunden | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.de/bildung/404",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
